// Mock data para Recanto Abelhinha
// IMPORTANTE: Este arquivo será substituído pelo config.js no futuro
// Para editar o conteúdo do site, use /app/frontend/src/config.js

import { siteConfig } from './config';

export const mockData = {
  school: {
    name: siteConfig.escola.nome,
    tagline: siteConfig.escola.tagline,
    since: siteConfig.escola.anoFundacao,
    yearsOfExperience: siteConfig.escola.anosExperiencia,
    phone: siteConfig.escola.telefone1,
    phone2: siteConfig.escola.telefone2,
    whatsapp: siteConfig.escola.whatsapp,
    email: siteConfig.escola.email,
    address: siteConfig.escola.endereco,
    mapsLink: siteConfig.escola.linkMaps,
    schedule: siteConfig.escola.horarioFuncionamento,
    visitPolicy: siteConfig.escola.politicaVisitas,
    socialMedia: {
      instagram: siteConfig.escola.instagram,
    }
  },
  
  hero: {
    title: siteConfig.hero.titulo,
    subtitle: siteConfig.hero.subtitulo,
    description: siteConfig.hero.descricao,
    image: siteConfig.hero.imagemFundo,
  },

  about: {
    title: siteConfig.sobre.titulo,
    description: siteConfig.sobre.descricao,
    mission: siteConfig.sobre.missao,
    values: siteConfig.sobre.valores,
    image: siteConfig.sobre.imagem
  },

  programs: siteConfig.programas.map(prog => ({
    id: prog.id,
    name: prog.nome,
    ageRange: prog.faixaEtaria,
    description: prog.descricao,
    features: prog.caracteristicas,
    image: prog.imagem
  })),

  facilities: siteConfig.instalacoes.map((inst, index) => ({
    id: inst.id,
    title: inst.titulo,
    description: inst.descricao,
    icon: ["Palette", "TreePine", "UtensilsCrossed", "BookOpen"][index]
  })),

  activities: siteConfig.atividades.map(ativ => ({
    id: ativ.id,
    name: ativ.nome,
    description: ativ.descricao,
    image: ativ.imagem
  })),

  testimonials: siteConfig.depoimentos.map(dep => ({
    id: dep.id,
    name: dep.nome,
    role: dep.cargo,
    text: dep.texto,
    rating: 5
  })),

  faq: siteConfig.faq.map(item => ({
    id: item.id,
    question: item.pergunta,
    answer: item.resposta
  }))
};
